import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { map } from 'rxjs';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { ICreateSettingDTO, IUpdateSettingDTO } from '~/models/modules/Asset/Setting/settingDTO';
import { ApiServiceBase, API_NAMES } from '~/services/api';


@Injectable({ providedIn: 'root' })
export class SettingsService extends ApiServiceBase {

    constructor(injector: Injector, private http: HttpClient) {
        super(injector);
        this.setBase(API_NAMES.assets);
    }

    GetSettingById(id: number) {
        return this.client.get<any>(this._url(`/GetSettingById/${id}`));
    }

    GetSettingByName(name: string) {
        return this.client.get<any>(this._url(`/GetSettingByName/${name}`));
    }

    GetCategorySettings(categoryId: number) {
        return this.client.get<any>(this._url(`/GetCategorySettings/${categoryId}`));
    }

    CreateSetting(model: ICreateSettingDTO) {
        return this.client.post<any>(this._url(), model);
    }

    UpdateSetting(model: IUpdateSettingDTO) {
        const updateUrl = this._url(`/UpdateSetting`);
        return this.client.post<any>(updateUrl, model);
    }

    DeleteSetting(id: number) {
        return this.client.get<any>(this._url(`/DeleteSetting/${id}`));
    }

    private _url(v?: string | undefined) {
        v = v || '';
        var url = this.url(`/Settings${v}`);
        return url;

    }


}